import clsx from 'clsx'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from './SideBarItem.module.scss'

export const SideBarItem = ({ tabValue, isCollapsed, isMobile, onClose }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const active = location.pathname.includes(tabValue.path)

  const handleClick = () => {
    if (isMobile && onClose) onClose()
    if (tabValue.link) window.open(tabValue.link, '_blank')
    else navigate(tabValue.path)
  }

  if (!tabValue.hasPermissionToView) return null

  return (
    <button className={clsx(styles['tab'], active && styles['tab-active'])} onClick={handleClick} aria-label={tabValue.tabLabel + '-page'}>
      {tabValue.icon && <tabValue.icon inactive={false} />}
      {!isCollapsed && <span className={active ? styles['tab-active-text'] : styles['tab-inactive-text']}>{tabValue.tabLabel}</span>}
    </button>
  )
}
